<div class="container">
  <app-template [title]="'Patient'">
    <div class="all" [ngSwitch]="mode">
      <div *ngSwitchCase="'view'">
        <div style="display: flex; flex-direction: row; flex-wrap: wrap">
          <mat-form-field style="margin-left: 20px">
            <mat-label>Name</mat-label>
            <input
              matInput
              placeholder="Name"
              [(ngModel)]="searchText"
              (ngModelChange)="searchPatient($event)"
            />
          </mat-form-field>
          <mat-form-field style="margin-left: 20px">
            <mat-label>Reg</mat-label>
            <input
              matInput
              placeholder="Reg No"
              [(ngModel)]="searchNumber"
              (ngModelChange)="searchPatientRegNo($event)"
            />
          </mat-form-field>
          <mat-form-field style="margin-left: 20px">
            <mat-label>Phone</mat-label>
            <input
              matInput
              placeholder="Phone No"
              [(ngModel)]="searchNumber"
              (ngModelChange)="searchPatientPhone($event)"
            />
          </mat-form-field>
          <mat-form-field style="margin-left: 20px">
            <mat-label>Email</mat-label>
            <input
              matInput
              placeholder="Email"
              [(ngModel)]="searchEmail"
              (ngModelChange)="searchPatientEmail($event)"
            />
          </mat-form-field>
          <span class="form" style="margin-left: 20px">
            <mat-form-field class="size">
              <mat-label>Start Date</mat-label>
              <input
                [(ngModel)]="sd"
                matInput
                [matDatepicker]="dob"
                (dateChange)="startDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="dob"
              ></mat-datepicker-toggle>
              <mat-datepicker #dob></mat-datepicker>
            </mat-form-field>
          </span>
          <span class="form" style="margin-left: 20px">
            <mat-form-field class="size">
              <mat-label>End Date</mat-label>
              <input
                [(ngModel)]="ed"
                matInput
                [matDatepicker]="end"
                (dateChange)="endDateChange($event)"
              />
              <mat-datepicker-toggle
                matSuffix
                [for]="end"
              ></mat-datepicker-toggle>
              <mat-datepicker #end></mat-datepicker>
            </mat-form-field>
          </span>
          <button
            (click)="serachAll()"
            mat-raised-button
            color="primary"
            style="height: 35px; margin-top: 20px; margin-left: 20px"
          >
            {{ searchLoad ? "Searching..." : "Search" }}
          </button>
        </div>
        <div *ngIf="isLoading" style="margin-top: 10px" class="spinner">
          <mat-spinner></mat-spinner>
          <div class="space"></div>
        </div>
        <table id="table" *ngIf="!isLoading" style="width: 100%">
          <tr class="back">
            <th>Name</th>
            <th>Gender</th>
            <th>Reg Number</th>
            <th>Date of Birth</th>
            <th>Email</th>
            <th>Phone</th>
            <th>
              <!-- <button (click)="exportexcel()" mat-raised-button color="basic">
                Export To Excel
              </button> -->
              <div class="dropdown">
                <button class="dropbtn" mat-raised-button>Export To Excel</button>
                <div class="dropdown-content">
                  <a class="dropdown-item" (click)="exportCurrent()"
                    >Current Page</a
                  >
                  <a class="dropdown-item" (click)="exportAll()"
                    >All Records</a
                  >
                </div>
              </div>
            </th>
          </tr>
          <tr class="td" *ngFor="let patient of emplyees">
            <td>{{ patient.first_name }}</td>
            <td>{{ patient.sex }}</td>
            <td>{{ patient.registration_no }}</td>
            <td>{{ patient.date_of_birth | date }}</td>
            <td>{{ patient.E_mail_address }}</td>
            <td>{{ patient.mobile }}</td>
            <td>
              <button
                style="margin-right: 10px"
                mat-raised-button
                color="primary"
                (click)="edit(patient)"
              >
                View
              </button>
            </td>
          </tr>
        </table>
      </div>

      <div *ngSwitchCase="'edit'">
        <div class="all">
          <button
            style="margin-right: 10px; margin-bottom: 30px"
            mat-raised-button
            color="primary"
            (click)="back()"
          >
            Back
          </button>
          <table>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Name :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.first_name }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Sex :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.sex }}</div>
              </td>
            </tr>
            <tr>
              <td class="tr">
                <div class="lable">Age :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.age }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Date of Birth :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.date_of_birth | date }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Reg Number :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.registration_no }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Mobile :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.mobile }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Email :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.E_mail_address }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Narital Status :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.marital_status }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Status :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.status }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Registered On :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.registration_date | date }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">Country :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.country_of_birth }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">State :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.local_state }}</div>
              </td>
            </tr>
            <tr class="tr">
              <td class="tr">
                <div class="lable">City :</div>
              </td>
              <td class="tr">
                <div class="name">{{ patient?.local_city }}</div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </div>
  </app-template>
</div>
